import { TermsAndConditionsPage, TermsAndConditionsPageQuery } from '@/graphql/generated/graphql';

import { initializeApollo } from '../lib/apollo-client';
import requestHandler from '../requestHandler';
import { QUERY_TERMS_AND_CONDITIONS_PAGE } from '@/graphql/queries/terms-and-conditions/terms-and-conditions';

export const getPage = async () => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<TermsAndConditionsPageQuery>({
      query: QUERY_TERMS_AND_CONDITIONS_PAGE,
      fetchPolicy: 'cache-first',
    }),
  );

  return {
    page: data?.termsAndConditionsPage?.data?.attributes as TermsAndConditionsPage,
    error,
  };
};
